import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { verifyRain, type RainEvent } from "@crashx/shared";

export function RainAnnouncement({ rain }: { rain: RainEvent }) {
  const { t } = useTranslation();
  const [verified, setVerified] = useState<boolean | null>(null);
  useEffect(() => {
    let active = true;
    void verifyRain(rain)
      .then((valid) => {
        if (active) setVerified(valid);
      })
      .catch(() => {
        if (active) setVerified(false);
      });
    return () => {
      active = false;
    };
  }, [rain]);
  return (
    <li className="cx-chat-message text-sm">
      <p className="m-0">
        {t("chat.rainAnnouncement", { nick: rain.fromNick, amount: rain.amount, count: rain.recipients })}
      </p>
      <details>
        <summary>{t("chat.proof")}</summary>
        <p className={verified === false ? "text-danger" : "text-muted"}>
          {t(verified === null ? "app.loading" : verified ? "chat.verified" : "chat.invalidProof")}
        </p>
        <dl className="break-all text-xs">
          <dt>{t("chat.commitment")}</dt>
          <dd>{rain.commitment}</dd>
          <dt>{t("chat.serverSeed")}</dt>
          <dd>{rain.serverSeed}</dd>
          <dt>{t("chat.clientSeed")}</dt>
          <dd>{rain.clientSeed}</dd>
        </dl>
        <a
          className="cx-nav-link"
          href={`/api/v1/chat/rain/${encodeURIComponent(rain.id)}`}
          target="_blank"
          rel="noreferrer"
        >
          {t("chat.fullProof")}
        </a>
      </details>
    </li>
  );
}
